/**
 * Assign and apply the default properties including overrides.
 *
 * @param {Object} overrides
 * @param {Object} defaults
 * @return {Object}
 */
function assignProperties(overrides = {}, defaults = {}) {
    return {
        ...defaults,
        ...overrides,
    };
}

const Tracking = {
    /**
     * Default properties to send with every event.
     */
    defaultProperties: {},

    /**
     * Initialize the GTM tracking script a.k.a the GTM Snippet.
     *
     * @param {String} tagId
     * @return {void}
     */
    init: tagId => {
        /* eslint-disable */
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            dataLayer.push(arguments);
        }
        gtag('js', new Date());

        gtag('config', tagId, {
            /**
             * We disable automatic page view events in favour of
             * creating them ourselves. This allows us to pass additional
             * data with each event.
             */
            send_page_view: false,
        });
        /* eslint-enable */
    },

    // todo: implement method of checking script has loaded
    ready: () => {
        return new Promise(resolve => {
            resolve();
        });
    },

    /**
     * Configure the default properties to use for all tracking calls.
     *
     * @param {Object} properties
     * @return {void}
     */
    setDefaultProperties: properties => {
        Tracking.defaultProperties = properties;
    },

    /**
     * Track an event.
     *
     * @param  {String} event
     * @param  {Object} properties
     */
    track: (event, properties = {}) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event,
            ...assignProperties(properties, Tracking.defaultProperties),
        });
    },
};

export default Tracking;
